export function userHasPermission(user, permissionName) {
  if (!user || !permissionName) return false;
  if (Array.isArray(user.permissions)) {
    return user.permissions.some(permission => permission && permission.name === permissionName);
  }
  return Array.isArray(user.roles) && user.roles.some(role =>
    Array.isArray(role.permissions) && role.permissions.some(permission => permission.name === permissionName)
  );
}

export function userHasAnyPermission(user, permissionNames = []) {
  return permissionNames.some(permission => userHasPermission(user, permission));
}
